"use client";

import { useLocale, useTranslations } from "next-intl";

// 진입 화면(랜딩·로그인·가입)용 언어 전환 pill. 라우팅 없는 모드라 URL 은 그대로 두고
// 로케일 쿠키(NEXT_LOCALE)만 바꾼 뒤 새로고침 → 서버가 i18n/request.ts 에서 쿠키를 읽어 다시 렌더.
// 기본은 한국어이므로, 여기서 켜기 전까지 기존 사용자에겐 아무 변화가 없다.
export function LangToggle({ className = "" }: { className?: string }) {
  const locale = useLocale();
  const t = useTranslations("common");
  const next = locale === "ko" ? "en" : "ko";
  const label = next === "en" ? t("toEnglish") : t("toKorean");

  function switchTo() {
    // 1년 유지. path=/ 로 전 경로 공유. SameSite=Lax 로 일반 내비게이션에 실림.
    document.cookie = `NEXT_LOCALE=${next};path=/;max-age=31536000;SameSite=Lax`;
    window.location.reload();
  }

  return (
    <button
      type="button"
      onClick={switchTo}
      aria-label={t("switchLanguage")}
      // viewportFit=cover(노치 밑까지 확장) 때문에 top 고정값이면 상태바/노치에 잘린다 →
      // safe-area 인셋을 더해 항상 노치 아래·모서리 안쪽에 앉힌다.
      style={{
        top: "calc(env(safe-area-inset-top, 0px) + 14px)",
        right: "calc(env(safe-area-inset-right, 0px) + 14px)",
      }}
      className={`entry-lang-toggle fixed z-50 inline-flex items-center gap-1.5 rounded-full border border-[rgba(58,91,200,.28)] bg-white/70 px-3.5 py-1.5 text-[13px] font-semibold text-[#3A5BC8] shadow-[0_4px_14px_rgba(58,91,200,.12)] backdrop-blur-md transition-all duration-200 hover:-translate-y-0.5 hover:bg-white/90 ${className}`}
    >
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18" />
      </svg>
      {label}
    </button>
  );
}
